window.onerror = (msg) => {
    console.log(`DC Errors Handler - ${msg}`);
};
